import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)

	return {
		"id": id,
		"elements": [
			{
				"type": "shape",
				"id": "tJ_RKWxpnS",
				"width": 940.89,
				"height": 394.48,
				"left": 29.53,
				"top": 133.85,
				"viewBox": [
					940.89,
					394.48
				],
				"path": "M 49.31 0 L 891.5799999999999 0 Q 940.89 0 940.89 49.31 L 940.89 345.17 Q 940.89 394.48 891.5799999999999 394.48 L 49.31 394.48 Q 0 394.48 0 345.17 L 0 49.31 Q 0 0 49.31 0 Z",
				"fill": "#3f3f46",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": true,
				"flipV": true,
				"pathFormula": "roundRect",
				"keypoint": 0.125
			},
			{
				"type": "shape",
				"id": "Tu42lKVbRn",
				"width": 940.89,
				"height": 83.23,
				"left": 29.58,
				"top": 32.03,
				"viewBox": [
					940.89,
					83.23
				],
				"path": "M 10.40375 0 L 930.48625 0 Q 940.89 0 940.89 10.40375 L 940.89 72.82625 Q 940.89 83.23 930.48625 83.23 L 10.40375 83.23 Q 0 83.23 0 72.82625 L 0 10.40375 Q 0 0 10.40375 0 Z",
				"fill": "#b07a58",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125
			},
			{
				"type": "shape",
				"id": "Of0lsKO7_D",
				"width": 15.15,
				"height": 15.15,
				"left": 45.57,
				"top": 66.09,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "#3f3f46",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "yxry33ZhjG",
				"width": 15.15,
				"height": 15.15,
				"left": 938.44,
				"top": 66.09,
				"viewBox": [
					200,
					200
				],
				"path": "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
				"fill": "#3f3f46",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "text",
				"id": "34pze1VYKA",
				"width": 258.49,
				"height": 48.5625,
				"left": 370.76,
				"top": 52.24,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 汉仪粗简黑简;\"><span style=\"color: #E8E2D6;\">RART&nbsp;${serial}</span></span></span></strong></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "slPgHUTFEN",
				"width": 38.1,
				"height": 19.05,
				"left": 428.86,
				"top": 426,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "#b07a58",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "yaO5R6NowX",
				"width": 38.1,
				"height": 19.05,
				"left": 466.96000000000004,
				"top": 426,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "#b07a58",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "WRUw1t3pAd",
				"width": 38.1,
				"height": 19.05,
				"left": 498.71000000000004,
				"top": 426,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "#b07a58",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "shape",
				"id": "k9ZLkNbcvQ",
				"width": 38.1,
				"height": 19.05,
				"left": 530.46,
				"top": 426,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
				"fill": "#b07a58",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#203864",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 等线;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "text",
				"id": "LiDZxhOABi",
				"left": 350.61564362336117,
				"top": 251.09000000000006,
				"width": 298.7187127532777,
				"height": 80,
				"content": `<p style=\"text-align: center;\"><strong><span style=\"font-size: 40px;\"><span style=\"color: rgba(255,255,255,1);\">${title}</span></span></strong></p>`,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"vertical": false
			}
		],
		background
	}
}